import SectionHeading from "@/components/base/SectionHeading";
import { gossipTimeline } from "@/mocks/gossip";

const levelStyle: Record<string, string> = {
  已确认: "bg-primary-100 text-primary-700 border-primary-200",
  媒体报道: "bg-accent-100 text-accent-800 border-accent-200",
  传闻: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

const levelHint: Record<string, string> = {
  已确认: "有官方声明的消息",
  媒体报道: "有媒体来源，双方未完全回应",
  传闻: "尚未得到证实",
};

export default function GossipSection() {
  return (
    <section id="gossip" className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="明星绯闻动态"
          title="戏外的那些风声，按时间给你理清"
          desc="绯闻最怕真假混在一起。我们按时间排列，并为每条消息标注来源层级——已确认、媒体报道还是尚未证实的传闻，让你心里有数再判断。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <ol className="reveal lg:col-span-8 relative">
            <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300"></span>
            {gossipTimeline.map((item) => (
              <li key={item.title} className="relative pl-8 pb-8 last:pb-0">
                <span className="absolute left-0 top-1.5 w-3.5 h-3.5 rounded-full bg-background-50 border-2 border-primary-500"></span>
                <div className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-2">
                    <span className="text-xs font-label text-foreground-500">{item.date}</span>
                    <span
                      className={`px-2.5 py-0.5 rounded-full border text-[11px] font-label font-medium ${levelStyle[item.level]}`}
                    >
                      {item.level}
                    </span>
                    <span className="text-[11px] text-foreground-400">{levelHint[item.level]}</span>
                  </div>
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-0.5 rounded-md bg-background-100 text-[11px] text-foreground-600 font-label"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6 sticky top-24">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-information-line text-primary-500"></i>
                <h3 className="font-heading font-semibold text-foreground-950">可信度怎么看</h3>
              </div>
              <ul className="space-y-4">
                {Object.keys(levelStyle).map((level) => (
                  <li key={level} className="flex gap-3">
                    <span
                      className={`mt-0.5 px-2.5 py-0.5 h-fit rounded-full border text-[11px] font-label font-medium whitespace-nowrap ${levelStyle[level]}`}
                    >
                      {level}
                    </span>
                    <p className="text-sm text-foreground-600 leading-relaxed">{levelHint[level]}</p>
                  </li>
                ))}
              </ul>
              <p className="mt-5 pt-4 border-t border-background-200 text-xs text-foreground-500 leading-relaxed">
                提示：绯闻仅供参考与讨论，涉及艺人私生活的消息请以官方与权威媒体为准，不作定论。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}